export const SP_BOTTOM_NAV_HEIGHT = 71;
